import { ROUTE_DASHBOARD } from '@/constants/routes';
import { useSetIntercomIsVisible } from '@/queries/layout.queries';
import { Button, Flex, Image, Link, Text } from '@cmpsr/components';
import { useState } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { DashboardNavigationBarProps } from '../types';
import MobileNavigationMenu from './mobile-navigation-menu/mobile-navigation-menu';

export default function DashboardNavigationBarMobile(props: DashboardNavigationBarProps) {
  const [localIsOpened, setLocalIsOpened] = useState(false);
  const mutateIntercomIsVisible = useSetIntercomIsVisible();
  const isLight = props.variant === 'light';

  // Use lifted state if provided, otherwise fall back to local state
  const isOpened = props.isMobileMenuOpen ?? localIsOpened;
  const setIsOpened = props.setIsMobileMenuOpen ?? setLocalIsOpened;

  return (
    <Flex
      as="nav"
      justifyContent="space-between"
      alignItems="center"
      height={{ base: '56px', md: '72px' }}
      px={{ base: 'spacer-4', md: 'spacer-8' }}
      py="spacer-3"
      w="100%"
      zIndex="20"
      position="relative"
      overflow="hidden"
      background={isLight ? 'white' : undefined}
      borderBottom={isLight ? '1px solid' : undefined}
      borderColor={isLight ? 'gray.200' : undefined}
      _before={isLight ? undefined : {
        content: '""',
        position: 'absolute',
        top: '-60px',
        left: '-60px',
        right: '-60px',
        bottom: '-60px',
        filter: 'blur(30px)',
        zIndex: -1,
        clipPath: 'inset(0 0 60px 0)',
      }}
      {...props.containerProps}
      ref={props.navBarRef}
    >
      <Link
        width="auto"
        to={ROUTE_DASHBOARD}
        as={ReactRouterLink}
        aria-label="Navigate home"
        alignItems="center"
        justifyContent="flex-start"
        gap={0}
      >
        <Image
          src={isLight ? "/images/dark-catch-logo-spelled.svg" : "/images/logo-catch.svg"}
          width="112px"
          height="20px"
          alt="Catch logo"
        />
        <Text as="span" display="inline-block" mt="-20px" color={isLight ? '#183344' : 'white'} fontSize="12px" fontWeight="400">
          beta
        </Text>
      </Link>
      <Button
        variant="accent"
        size="s"
        onClick={() => {
          setIsOpened(true);
          mutateIntercomIsVisible.mutateAsync(false);
        }}
      >
        Menu
      </Button>
      {isOpened && (
        <MobileNavigationMenu
          onClose={() => {
            setIsOpened(false);
            mutateIntercomIsVisible.mutateAsync(true);
          }}
          {...props}
        />
      )}
    </Flex>
  );
}
